import React from 'react';
import { Box, Typography, Popover } from '@mui/material';
import { Sort, InfoOutlined, WarningAmber } from '@mui/icons-material';
import { AppButton } from '../../../components/UI';
import { HelpBox, ModeSelector, NumberChoice, SectionTitle, popoverPaperSx } from './SearchSettings';

const RerankPopover = ({
    anchorEl,
    onClose,
    filter,
    setFilter,
    shortlistLimit,
    setShortlistLimit,
    limit,
    setLimit,
    onRerank,
    rerankLoading,
    limitOptions = [20, 30, 40, 50, 60],
    itemLabel = 'candidats',
}) => {
    const tooFew = limit > shortlistLimit;

    return (
        <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            slotProps={{ paper: { sx: popoverPaperSx } }}
        >
            <Typography sx={{ fontWeight: 700, fontSize: '0.85rem', color: '#0f172a', mb: 1 }}>
                Affiner le classement
            </Typography>

            <HelpBox sx={{ mb: 2.5, background: '#f0f7fd', borderColor: '#aed6f1' }}>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <InfoOutlined sx={{ fontSize: 17, color: '#03407b', mt: 0.1 }} />
                    <Typography sx={{ fontSize: '0.76rem', color: '#334155', lineHeight: 1.5 }}>
                        Se fait en <b>2 étapes</b> : une première recherche rapide sélectionne une <b>shortlist</b>, puis l'IA
                        relit chaque profil de la shortlist <b>en détail</b> pour le comparer à la mission et refaire le classement.
                        <br />
                        Plus précis qu'une recherche simple, mais <b>plus lent</b>. À utiliser après une première recherche,
                        pour départager les meilleurs {itemLabel}.
                    </Typography>
                </Box>
            </HelpBox>

            <ModeSelector filter={filter} setFilter={setFilter} title="1. Mode de la première recherche" />

            <Box sx={{ mb: 2.5 }}>
                <SectionTitle hint={`Nombre de ${itemLabel} que l'IA va relire en détail. Plus c'est grand, plus c'est complet… et plus c'est long.`}>
                    2. Taille de la shortlist
                </SectionTitle>
                <NumberChoice value={shortlistLimit} setValue={setShortlistLimit} options={[10, 30, 50, 100]} withOther={false} />
            </Box>

            <Box sx={{ mb: tooFew ? 1.5 : 3 }}>
                <SectionTitle hint={`Nombre de ${itemLabel} gardés et affichés après le nouveau classement.`}>
                    3. Résultats affichés
                </SectionTitle>
                <NumberChoice value={limit} setValue={setLimit} options={limitOptions} />
            </Box>

            {tooFew && (
                <Box sx={{ display: 'flex', gap: 0.75, alignItems: 'flex-start', mb: 2.5, px: 1.25, py: 1, borderRadius: '10px', background: '#fffbeb', border: '1px solid #fcd34d' }}>
                    <WarningAmber sx={{ fontSize: 16, color: '#b45309', mt: 0.1 }} />
                    <Typography sx={{ fontSize: '0.74rem', color: '#92400e', lineHeight: 1.45 }}>
                        Vous demandez {limit} résultats mais la shortlist n'en contient que {shortlistLimit} :
                        vous aurez au maximum {shortlistLimit} {itemLabel}. Augmentez la shortlist si besoin.
                    </Typography>
                </Box>
            )}

            <AppButton variant="primary" fullWidth onClick={onRerank} disabled={rerankLoading} startIcon={<Sort fontSize="small" />}>
                Affiner le classement
            </AppButton>
            <Typography sx={{ fontSize: '0.7rem', color: '#94a3b8', textAlign: 'center', mt: 1 }}>
                Conseil : shortlist 30 et 20 résultats est un bon équilibre vitesse / précision.
            </Typography>
        </Popover>
    );
};

export default RerankPopover;
